import {
  AgentImportApi,
  AnalyticsApi,
  ApiClient,
  ApiKeyApi,
  AssistantMarketplaceApi,
  AssistantsApi,
  AssistantSharesApi,
  AuthApi,
  AutomationApi,
  CalendarApi,
  ChatApi,
  ChatFolderApi,
  ConnectorApprovalApi,
  ContentReportApi,
  CustomIntegrationApi,
  DashboardsApi,
  DocRecognitionApi,
  GeneratedFilesApi,
  GlobalSearchApi,
  HistoryApi,
  IntegrationApi,
  KnowledgeApi,
  ManusImportApi,
  MeetingsApi,
  ModelsApi,
  NotificationsApi,
  OrganizationApi,
  OrganizationSkillsApi,
  PageShareApi,
  PermissionsApi,
  PiiApi,
  ProbesApi,
  ProjectApi,
  PromptLibraryApi,
  ResearchFaviconsApi,
  SecurityDiagramApi,
  SkillsApi,
  SkillSharesApi,
  SubscriptionApi,
  TokenUsageApi,
  UserApi,
  UserCustomInstructionsApi,
  UserMemoryApi,
  VstrAudioApi,
  VstrVideoApi,
} from "@frontend-shared/api";

import { PATHS } from "@/constants/paths";
import i18n from "@/i18n";
import { getProjectUuid } from "@/lib/auth";
import { FLAVOR_CONFIG } from "@/lib/flavor-config";
import { rememberLicenseExpiredReturnPath } from "@/lib/license-expired-return-path";
import { localStorageAdapter } from "@/lib/storage-adapter";
import { clearLocalStorage } from "@/lib/utils";
import { websocketService } from "@/lib/websocket";

export const apiClient = new ApiClient({
  baseURL: "/api",
  storageAdapter: localStorageAdapter,
  platform: "web",
  defaultLanguage: FLAVOR_CONFIG.defaultLanguage,
  getLanguage: () => i18n.language,
  getProjectUuid,
  onUnauthorized: () => {
    clearLocalStorage();
    globalThis.location.href = PATHS.AUTH.SIGN_IN;
  },
  onLicenseExpired: () => {
    if (globalThis.location.pathname === PATHS.LICENSE_EXPIRED) {
      return false;
    }
    // NOTE: Save the current path so the license-expired page can restore it on reload
    rememberLicenseExpiredReturnPath();
    globalThis.location.href = PATHS.LICENSE_EXPIRED;
    return true;
  },
  onTokenRefresh: () => {
    websocketService.updateAuthAndReconnect();
  },
  shouldStoreRefreshToken: false,
});

export const apiKeyApi = new ApiKeyApi(apiClient);
export const analyticsApi = new AnalyticsApi(apiClient);
export const automationApi = new AutomationApi(apiClient);
export const authApi = new AuthApi(apiClient);
export const userApi = new UserApi(apiClient);
export const userMemoryApi = new UserMemoryApi(apiClient);
export const userCustomInstructionsApi = new UserCustomInstructionsApi(
  apiClient,
);
export const assistantsApi = new AssistantsApi(apiClient);
export const assistantMarketplaceApi = new AssistantMarketplaceApi(apiClient);
export const assistantSharesApi = new AssistantSharesApi(apiClient);
export const projectApi = new ProjectApi(apiClient);
export const modelsApi = new ModelsApi(apiClient);
export const notificationsApi = new NotificationsApi(apiClient);
export const meetingsApi = new MeetingsApi(apiClient);
export const vstrAudioApi = new VstrAudioApi(apiClient);
export const calendarApi = new CalendarApi(apiClient);
export const chatApi = new ChatApi(apiClient);
export const generatedFilesApi = new GeneratedFilesApi(apiClient);
export const globalSearchApi = new GlobalSearchApi(apiClient);
// NOTE: NSAI-7336 — Deep Research's source favicons, served by our API.
export const researchFaviconsApi = new ResearchFaviconsApi(apiClient);
export const chatFolderApi = new ChatFolderApi(apiClient);
export const organizationApi = new OrganizationApi(apiClient);
export const permissionsApi = new PermissionsApi(apiClient);
export const piiApi = new PiiApi(apiClient);
export const probesApi = new ProbesApi(apiClient);
export const promptLibraryApi = new PromptLibraryApi(apiClient);
export const securityDiagramApi = new SecurityDiagramApi(apiClient);
export const integrationApi = new IntegrationApi(apiClient);
export const connectorApprovalApi = new ConnectorApprovalApi(apiClient);
export const contentReportApi = new ContentReportApi(apiClient);
export const customIntegrationApi = new CustomIntegrationApi(apiClient);
// NOTE: NSAI-5657 / NSAI-5658 — saved dashboards.
export const dashboardsApi = new DashboardsApi(apiClient);
export const docRecognitionApi = new DocRecognitionApi(apiClient);
export const historyApi = new HistoryApi(apiClient);
export const knowledgeApi = new KnowledgeApi(apiClient);
export const manusImportApi = new ManusImportApi(apiClient);
export const agentImportApi = new AgentImportApi(apiClient);
export const skillsApi = new SkillsApi(apiClient);
export const skillSharesApi = new SkillSharesApi(apiClient);
export const organizationSkillsApi = new OrganizationSkillsApi(apiClient);
export const pageShareApi = new PageShareApi(apiClient);
export const subscriptionApi = new SubscriptionApi(apiClient);
export const tokenUsageApi = new TokenUsageApi(apiClient);
export const vstrVideoApi = new VstrVideoApi(apiClient);
